import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=46b6355c&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=46b6355c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b6355c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b6355c')) {
      api.createRecord('46b6355c', component.options)
    } else {
      api.reload('46b6355c', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=46b6355c&scoped=true&", function () {
      api.rerender('46b6355c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ib6qkiS439YT/JS/comp/GuestBox.vue"
export default component.exports